import { useEffect, useState } from "react";
import { Checkbox, Divider, Tooltip, Typography } from "antd";
import SearchInput from "../Forms/SearchInput";
import PrimaryButton from "../Forms/PrimaryButton";
import Paragraph from "antd/es/typography/Paragraph";

const { Title } = Typography;

const Access = ({
  text,
  plainOptions,
  setNewCustomers,
  setCustomers,
  customers,
  handleSubmit,
  data,
  loading,
}) => {
  const [tempOptions, setTempOptions] = useState(plainOptions);
  const [searchText, setSearchText] = useState("");
  const [alreadySelected, setAlreadySelected] = useState([]);

  const onChange = (e, itemId) => {
    const isChecked = e.target.checked;
    setCustomers((prev) => {
      const current = Array.isArray(prev) ? prev : [];
      return isChecked ? [...current, itemId] : current.filter((id) => id !== itemId);
    });
  };

  const onSearchChange = (e) => {
    const value = e.target.value;
    setSearchText(value);
    setTempOptions(
      plainOptions.filter((item) => item.company_name?.toLowerCase().includes(value.toLowerCase()))
    );
  };

  useEffect(() => {
    let userIds = data?.customers?.map((customer) => customer.customer_id);
    let defaultSelected;
    if (text == "Assign Client") {
      defaultSelected = plainOptions
        .filter((item) => userIds?.includes(item.customer_id))
        .map((item) => item.customer_id);
    } else if (text == "Edit Access") {
      defaultSelected = plainOptions
        .filter((item) => item.is_edit_allowed)
        .map((item) => item.customer_id);
    }

    setAlreadySelected(defaultSelected);
    setCustomers(defaultSelected);
    setTempOptions(plainOptions);
    setSearchText("");
  }, [plainOptions]);

  useEffect(() => {
    setNewCustomers([...customers.filter((id) => !alreadySelected.includes(id))]);
  }, [customers]);

  return (
    <>
      <Title className="input-css font-abhaya !m-0" level={2}>
        {text === "Assign Client" ? "Re-assign Clients" : "Update Edit Access"}
      </Title>
      <Paragraph className="input-css !my-2" level={5}>
        Assigned Salesperson - <strong>{data?.full_name}</strong>
      </Paragraph>

      <div className="flex items-center mt-4 gap-4 flex-wrap">
        <SearchInput value={searchText} onChange={onSearchChange} />
      </div>

      <div className="mt-6 space-y-3">
        <div className="w-full px-4 text-left flex">
          <span className="w-[25%] text-left font-medium text-gray-700">#</span>
          <span className="text-gray-900 text-left w-[75%]">Client Name</span>
        </div>
        <Divider />
        {tempOptions.map((item, i) => (
          <div key={i} className="flex justify-between items-center px-4 py-2 rounded-md bg-white">
            <div className="w-full text-left flex justify-between">
              <span className="font-medium text-gray-700">{i + 1}</span>
              <span className="text-gray-900 text-left w-1/2">{item.company_name}</span>
              <Tooltip
                title={
                  text == "Assign Client" && alreadySelected?.includes(item.customer_id)
                    ? "Already assigned"
                    : undefined
                }
              >
                <Checkbox
                  className="custom-checkbox"
                  disabled={text == "Assign Client" && alreadySelected?.includes(item.customer_id)}
                  checked={customers?.includes(item.customer_id)}
                  onChange={(e) => onChange(e, item.customer_id)}
                />
              </Tooltip>
            </div>
          </div>
        ))}
      </div>

      <div className="w-full mt-4 flex justify-center">
        <PrimaryButton
          text={text === "Assign Client" ? "Save and Proceed" : "Update Access"}
          onClick={handleSubmit}
          loading={loading}
          className="me-[30px]"
        />
      </div>
    </>
  );
};

export default Access;
